/*
 * Dependencies:
 * - jquery.slideshow.js
 * - YT api if you want the subscribe button (https://developers.google.com/youtube/subscribe/reference?hl=fr)
 */

define('components/factory/views/VideoProductView', [
    'components/factory/templates/videoproductview',
    'components/factory/views/VideoView',
    'components/trackingbridge/TrackingBridge'
], function(tpl, VideoView, TrackingBridge) {

    var VideoProductView = VideoView.extend({

        events: {
            "click .maz-videoproduct-video-steps-slideshow .js-maz-slide": "onVideoStepClick",
            "mouseenter .maz-videoproduct-video-steps-slideshow": "onEnterSlideshow",
            "mouseleave .maz-videoproduct-video-steps-slideshow": "onLeaveSlideshow",
            "mouseenter .mmm-control-bar-wrapper": "onEnterControls",
            "mouseleave .mmm-control-bar-wrapper": "onLeaveControls"
        },

        template: tpl,

        className: "maz-videoproduct-view",

        productModel: [],
        productView: [],
        currentProductCountClass: "",

        // Video Step Navigation Config Parameters
        maxStep: 5, // Max step to show
        currentStep: null,
        previousStep: null,
        autoStepChange: false,

        initialize: function(options) {
            VideoView.prototype.initialize.call(this, options);

            this.Factory = options.factory;
            this.productModel = [];
            this.productView = [];
        },

        afterRender: function() {
            VideoView.prototype.afterRender.call(this);

            // Add youtube channel on youtube video
            if( this.model.get("video").type === "youtube" ) {
                var $ytSubscribeBtn = this.$('.g-ytsubscribe');
                var options = {
                    'channelid': $ytSubscribeBtn.attr('data-channelid'),
                    'layout': $ytSubscribeBtn.attr('data-layout'),
                    'count': $ytSubscribeBtn.attr('data-count')
                };

                if(typeof gapi !== 'undefined') {
                    gapi.ytsubscribe.render($ytSubscribeBtn.get(0), options);
                }
            }

            if( this.model.get('showSteps') && this.model.get('video').timecodes){
                var nbStep = this.model.get('video').timecodes.length;
                var limit = [0, this.maxStep-1];

                if (nbStep < this.maxStep) {
                    this.$('.maz-videoproduct-video-steps-slideshow-wrapper').css({ 'width': 100 / nbStep + '%', 'marginLeft': 0 });
                }

                this.$('.maz-videoproduct-video-steps').addClass('maz-paused');

                this.$('.maz-videoproduct-video-steps-slideshow').slideshow({
                    prefix     : "maz",
                    speed      : 400,
                    method     : 'animate',
                    easing     : 'swing',
                    autoslide  : false,
                    shownav    : false,
                    preview    : false,
                    control    : (nbStep > this.maxStep),
                    controlWrapper : this.$('.maz-videoproduct-video-steps'),
                    loop       : false,
                    limit      : limit,
                    callsync   : _.bind(function($slides, oldIndex, newIndex) {
                        if (!this.autoStepChange) {
                            this.goToStep( newIndex, true );
                        }
                    }, this)
                });

                if (nbStep >= this.maxStep) {
                    this.$('.maz-videoproduct-video-steps-slideshow').css('left', "0%");
                }
            }

            // Add the share outside the video as on MakeUpHowTo and Skincare
            if( this.model.get('video').share ){
                obj = _.extend({
                    "type": "shareview",
                    "viewId": "share-view-" + this.model.get("video").videoId
                }, this.model.get('video').share);

                this.shareModel = this.Factory.createModelFromData(obj);
                this.shareView = this.Factory.createViewFromModel(this.shareModel);

                this.$('.maz-videoproduct-share').html( this.shareView.render().$el );
                this.shareView.afterRender();
            }

            // Adjust the size of the right column
            if (this.$('.maz-videoproduct-col1-3').length) {
                this.resizeCell();
                var throttledResizeCellHeight = _.throttle(this.resizeCell, 500);
                $(window).on('resize', throttledResizeCellHeight);
            }
        },

        destroy: function() {
            VideoView.prototype.destroy.call(this);
            //TODO remove share ?
        },

        onPlayerReady: function() {
            VideoView.prototype.onPlayerReady.call( this );

            if( this.model.get('startStep') !== -1 ) {
                this.goToStep( this.model.get('startStep'), this.videoModel.get('autoplay') );
            }
        },

         /*
          * Gestion Timecodes
          */
        onCurrentTimeChange: function( model, time ) {
            VideoView.prototype.onCurrentTimeChange.call(this, model, time);

            if( this.model.get('showSteps') ){
                var currentStep = -1,
                    timecodes = this.model.get('video').timecodes;

                _.each( timecodes, function( item, index ){
                    if( time >= item.timeStart ){
                        currentStep = index;
                    }
                });

                if( this.previousStep !== currentStep ){
                    this.previousStep = currentStep;
                    this.onStepChange( currentStep );
                }
            }
        },

        /*
         * Call on each step change
         * Update the product(s) on the right, the title of the step and eventually the slideshow position
         */
        onStepChange: function( index ){
            this.currentStep = index;

            if( index >= 0 ){
                TrackingBridge.trackEvent('videostep', {"{{videotype}}": this.model.get('video').type.toUpperCase(), "{{videoid}}": this.model.get('video').videoId, "{{stepindex}}": index});
            }

            if (this.$('.maz-videoproduct-video-steps-slideshow').data('slideshow')) {
                this.autoStepChange = true;
                this.$('.maz-videoproduct-video-steps-slideshow').data('slideshow').slideTo(index);
                this.autoStepChange = false;
            }

            this.$('.maz-videoproduct-products-wrapper').removeClass( this.currentProductCountClass );

            if( index === -1 ){

                // IF OUT OF STEP
                this.$('.maz-videoproduct-video-step-title').html("");

                this.productModel = [];
                this.productView = [];

                this.$('.maz-videoproduct-products-wrapper').empty();

            } else {

                var timecodeInfo = this.model.get('video').timecodes[index];
                if (this.model.get('showStepIntoVideoInfos')) { //TODO data-steplabel à faire passer depuis app_delegate
                    this.$('.maz-videoproduct-video-step-title').html('<span>' + this.$('.maz-videoproduct-row').attr('data-steplabel') + ' ' + timecodeInfo.step_id + '</span> : ' + timecodeInfo.label );
                } else {
                    this.$('.maz-videoproduct-video-step-title').hide();
                    this.$('.mmm-description').text(this.$('.maz-videoproduct-row').attr('data-steplabel') + ' ' + timecodeInfo.step_id + ' : ' + timecodeInfo.label);
                }

                this.$('.maz-videoproduct-products-title').text(this.$('.maz-videoproduct-row').attr('data-steplabel') + ' ' + timecodeInfo.step_id);

                timecodeInfo.products = _.reject(timecodeInfo.products, function(product){ return product.codeY === ""; });

                this.currentProductCountClass = 'maz-product-count-' + timecodeInfo.products.length;
                this.$('.maz-videoproduct-products-wrapper').addClass( this.currentProductCountClass );

                this.$('.maz-videoproduct-products-wrapper').empty();

                // FOR EACH PRODUCT CREATE PRODUCT MODEL + VIEW
                _.each( timecodeInfo.products, _.bind(function( item, index ){

                    var obj = _.extend( {
                        "type": "productview",
                        "viewId": "videoproduct-product-view-" + item.codeY,
                        "suffixClass": (timecodeInfo.products.length > 1) ? "basic-multi" : "basic-simple",
                        "positionInPage": this.currentStep + 1
                    }, item);

                    if( this.model.get('currentSiteTitle') ) {
                        obj.currentSiteTitle = this.model.get('currentSiteTitle') + " - " + this.model.get('video').videoId;
                    }

                    this.productModel[index] = this.Factory.createModelFromData(obj);
                    this.productView[index] = this.Factory.createViewFromModel(this.productModel[index]);

                    this.$('.maz-videoproduct-products-wrapper').prepend( this.productView[index].render().$el );
                    if( this.productView[index].afterRender ){
                        this.productView[index].afterRender();
                    }
                }, this));

                // DESTROY USELESS VIEW
                var start = timecodeInfo.products.length,
                    end = this.productModel.length;

                for( var i = end; i >= start ; i-- ){
                    if( !_.isUndefined( this.productModel[i] ) ){
                        this.productModel.splice(i, 1);
                    }

                    if( !_.isUndefined( this.productView[i] ) ){
                        this.productView[i].remove();
                        this.productView.splice(i, 1);
                    }
                }
            }
        },

        /*
         * Handle the click on a step
         */
        onVideoStepClick: function( e ){
            var $slide = $(e.currentTarget);
            var index = this.$('.maz-videoproduct-video-steps-slideshow .slide').index($slide);
            this.$('.maz-videoproduct-video-steps-slideshow').data('slideshow').slideTo(index);
        },

        /*
         * Update the current time of the video according to the step
         * -> stepIndex: index of the step in the timecodes array
         * -> autoplay: go to the correct timecode and autoplay video or not
         */
        goToStep: function( stepIndex, autoplay ){
            if( stepIndex < this.model.get('video').timecodes.length ) {
                var timecodeInfo = this.model.get('video').timecodes[ stepIndex ];
                this.videoView.setCurrentTime( timecodeInfo.timeStart, true );
                this.onCurrentTimeChange(this.model, this.model.get('video').timecodes[ stepIndex ].timeStart);

                if( autoplay ) {
                    this.videoView.play();
                } else {
                    this.videoView.pause();
                }
            }
        },

        resizeCell: function() {
            this.$('.maz-videoproduct-col1-3').each(function(){
                $(this).height( $(this).prev('.maz-videoproduct-col2-3').outerHeight() );
            });
        },

        onEnterSlideshow: function( e ) {
            this.$('div.mmm-player').removeClass('mmm-no-controls');
        },

        onLeaveSlideshow: function( e ) {
            this.$('div.mmm-player').addClass('mmm-no-controls');
        },

        onEnterControls: function( e ) {
            this.$('.maz-videoproduct-video-steps').css('opacity', '1');
        },

        onLeaveControls: function( e ) {
            this.$('.maz-videoproduct-video-steps').removeAttr("style");
        }

    });

    return VideoProductView;
});
